// current aspect ratio
const ASPECT_RATIO = 2;

interface ImageWidth {
  aspect: number;
  width: number;
  x: number;
  y: number;
}

const getWidth = (image: any, aspectRatio: any): number =>
  image.width < image.height * aspectRatio ? image.width : image.height * aspectRatio;

export default (imageRotations: any, rotatedIndex: any, ratio: any): ImageWidth => {
  const aspectRatio = ratio || ASPECT_RATIO;
  const image = imageRotations[rotatedIndex];

  return {
    aspect: aspectRatio,
    width: getWidth(image, aspectRatio),
    x: 0,
    y: 0,
  };
};
